import { render, staticRenderFns } from "./MyGreeting.vue?vue&type=template&id=50bc2080"
import script from "./MyGreeting.vue?vue&type=script&lang=js"
export * from "./MyGreeting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports